import * as React from "react";
const PersonalPortfoiliSVG = (props) => (
  <svg
    className="animated"
    id="freepik_stories-resume"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    xmlnsXlink="http://www.w3.org/1999/xlink"

    {...props}
  >
    <style>
      {
        "svg#freepik_stories-resume:not(.animated) .animable {opacity: 0;}svg#freepik_stories-resume.animated #freepik--background-simple--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-resume.animated #freepik--Shadow--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-resume.animated #freepik--Plants--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-resume.animated #freepik--Resume--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-resume.animated #freepik--Character--inject-7 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}            @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }"
      }
    </style>
    <g
      id="freepik--background-simple--inject-7"
      className="animable"
      style={{
        transformOrigin: "239.802px 238.812px",
      }}
    >
      <path
        d="M429.22,294.44a225.14,225.14,0,0,0-8.65-38.79c-4.29-14-9.29-28.11-8.77-42.71.37-10.29,3.48-20.27,5-30.46,2.49-16.29.95-33.06-3.34-49-3.09-11.45-7.67-22.67-15-32-6.56-8.35-15.14-15-24.38-20.18-24.42-13.81-53-18.16-81-20-26.88-1.8-54.31-1.47-80.18,6a122.38,122.38,0,0,0-75.14,61.84c-16.63,32.56-26.25,69.15-49.55,98-12.3,15.23-28.34,28.18-35.38,46.44-10.07,26.11,2.44,57.57,25.26,73.77,14.39,10.22,31.82,15.1,47.46,23.29,14.43,7.55,27.25,17.87,41.46,25.83C219.21,425.7,284,420,341.63,404.24c28.82-7.85,59-19.48,75.54-44.36C429.85,340.77,432,317.62,429.22,294.44Z"
        style={{
          fill: "#213E60",
          transformOrigin: "239.802px 238.812px",
        }}
        id="elnih4o3ski9g"
        className="animable"
      />
      <g id="elzk30j65msbm">
        <path
          d="M429.22,294.44a225.14,225.14,0,0,0-8.65-38.79c-4.29-14-9.29-28.11-8.77-42.71.37-10.29,3.48-20.27,5-30.46,2.49-16.29.95-33.06-3.34-49-3.09-11.45-7.67-22.67-15-32-6.56-8.35-15.14-15-24.38-20.18-24.42-13.81-53-18.16-81-20-26.88-1.8-54.31-1.47-80.18,6a122.38,122.38,0,0,0-75.14,61.84c-16.63,32.56-26.25,69.15-49.55,98-12.3,15.23-28.34,28.18-35.38,46.44-10.07,26.11,2.44,57.57,25.26,73.77,14.39,10.22,31.82,15.1,47.46,23.29,14.43,7.55,27.25,17.87,41.46,25.83C219.21,425.7,284,420,341.63,404.24c28.82-7.85,59-19.48,75.54-44.36C429.85,340.77,432,317.62,429.22,294.44Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.8,
            transformOrigin: "239.802px 238.812px",
          }}
          className="animable"
          id="el5vke7018xxi"
        />
      </g>
    </g>
    <g
      id="freepik--Shadow--inject-7"
      className="animable"
      style={{
        transformOrigin: "256.28px 424.23px",
      }}
    >
      <ellipse
        cx={256.28}
        cy={424.23}
        rx={168.79}
        ry={11.62}
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "256.28px 424.23px",
        }}
        id="elt49nedv2wih"
        className="animable"
      />
    </g>
    <g
      id="freepik--Plants--inject-7"
      className="animable animator-hidden"
      style={{
        transformOrigin: "240.483px 317.525px",
      }}
    >
      <path
        d="M154.88,336.69c-.7-3.38-1.63-8.23-2.48-14.09-.25-1.69-.49-3.48-.71-5.33.76-.14,6.8-1.32,9.15-3,2.14-1.51,4.44-4,4.53-6.8a4.64,4.64,0,0,0-4.83-5c-3.92.27-7.54,6.35-8.39,9.76-.05.22-.4,2.86-.55,4.22-.13-1.12-.26-2.23-.38-3.39-.18-1.68-.32-3.45-.46-5.17,0-.9-.09-1.8-.13-2.71s0-1.8,0-2.72c0-1.34.1-2.73.17-4.11,1.72-.08,6.75-.41,9-1.55s5-3.31,5.51-6a4.66,4.66,0,0,0-4-5.63c-3.91-.32-8.42,5.14-9.76,8.38-.05.1-.26.82-.51,1.67.12-1.35.23-2.7.4-4.06.46-3.85,1.06-7.77,1.64-11.7.12-.82.23-1.63.35-2.45,1.44-.07,6.9-.37,9.27-1.56s5-3.32,5.51-6a4.65,4.65,0,0,0-4-5.63c-3.92-.32-8.42,5.14-9.77,8.38,0,.11-.3,1-.58,1.92.29-2.13.54-4.27.73-6.39a81.19,81.19,0,0,0,.31-11c.51,0,6.91-.25,9.55-1.57,2.35-1.17,5-3.31,5.51-6a4.64,4.64,0,0,0-4-5.62c-3.92-.33-8.42,5.14-9.77,8.37-.1.23-1,3.33-1.27,4.44a.57.57,0,0,1,0-.13,61,61,0,0,0-1.64-10.65,83.36,83.36,0,0,0-2.8-9.22c-1-2.8-2.09-5.31-3.07-7.52-.54-1.2-1.06-2.28-1.55-3.28l.08,0c.07,0-.12-4.75-.16-5-.54-3.46-3.61-9.84-7.49-10.46a4.64,4.64,0,0,0-5.25,4.5c-.16,2.77,1.91,5.48,3.9,7.18s7.37,3.36,8.69,3.74c.49,1.06,1,2.19,1.55,3.45.93,2.23,2,4.75,2.89,7.57.25.75.49,1.57.74,2.35-.69-1.24-1.66-2.93-1.78-3.08-2.07-2.83-7.74-7.08-11.46-5.84a4.64,4.64,0,0,0-2.59,6.41c1.13,2.53,4.22,4,6.78,4.57s8.26-.44,9.48-.68c.52,1.75,1,3.56,1.42,5.48A59.71,59.71,0,0,1,154,256.23c0,.21,0,.42,0,.63-.24-.68-1.8-4.27-1.93-4.51-1.75-3-6.92-7.89-10.76-7.07a4.65,4.65,0,0,0-3.28,6.1c.85,2.63,3.77,4.42,6.24,5.28,2.85,1,9.48.36,9.72.34a81.27,81.27,0,0,1-.53,10.6c-.29,2.61-.69,5.24-1.12,7.87-.33-.87-1.77-4.21-1.91-4.44-1.74-3-6.91-7.88-10.75-7.06a4.65,4.65,0,0,0-3.28,6.09c.85,2.64,3.76,4.42,6.24,5.29,2.78,1,9.13.39,9.67.34-.2,1.19-.39,2.39-.59,3.59-.67,3.9-1.35,7.82-1.9,11.7-.2,1.35-.34,2.68-.48,4-.53-1.29-1.54-3.61-1.65-3.8-1.75-3-6.92-7.89-10.76-7.06a4.65,4.65,0,0,0-3.28,6.09c.85,2.64,3.76,4.42,6.24,5.29s7.83.49,9.34.37c-.23,2.22-.4,4.43-.47,6.61,0,.94-.09,1.91,0,2.81s0,1.82.06,2.71c.12,1.85.21,3.57.36,5.29.07.87.15,1.69.23,2.53-.34-1.38-.92-3.57-1-3.76-1.27-3.27-5.64-8.84-9.57-8.61a4.66,4.66,0,0,0-4.16,5.53c.44,2.73,3,4.94,5.36,6.17,2.56,1.35,8.71,1.75,9.46,1.8.2,2.06.42,4.07.65,5.94.74,5.94,1.57,10.85,2.2,14.29s1.08,5.39,1.08,5.39v0a1.38,1.38,0,1,0,2.67-.66S155.58,340.08,154.88,336.69Z"
        style={{
          fill: "#213E60",
          transformOrigin: "151.551px 276.891px",
        }}
        id="elj7lshh6n4jg"
        className="animable"
      />
      <path
        d="M151.52,239.53s6.6-2,8.89-4.07c2-1.74,4-4.51,3.71-7.28a4.64,4.64,0,0,0-5.36-4.36c-3.86.72-6.77,7.18-7.21,10.66C151.51,234.78,151.45,239.55,151.52,239.53Z"
        style={{
          fill: "#213E60",
          transformOrigin: "157.818px 231.647px",
        }}
        id="elxblwmvzfr69"
        className="animable"
      />
      <path
        d="M155,343.69a1.38,1.38,0,1,1-1.86,2h0s-1.46-1.4-3.87-3.91-5.83-6.16-9.72-10.7c-1.23-1.44-2.51-3-3.82-4.6-.65.37-6,3.43-8.88,3.71-2.61.25-6-.15-7.88-2.19a4.65,4.65,0,0,1,.42-6.9c3.15-2.36,9.87-.12,12.73,1.91.17.12,1.86,1.62,2.9,2.58-.53-.66-1-1.29-1.59-2-1.07-1.35-2.1-2.73-3.21-4.22l-1.55-2.22c-.54-.73-1-1.57-1.52-2.36-1.15-1.86-2.22-3.8-3.25-5.78-1.19.93-5.45,4.19-8,4.84s-6,.76-8.12-1a4.65,4.65,0,0,1-.63-6.89c2.76-2.8,9.74-1.61,12.87,0,.2.1,2.32,1.48,3.47,2.26-.61-1.2-1.23-2.39-1.81-3.62-1.68-3.54-3.27-7.18-4.87-10.81-.49-1.11-1-2.21-1.49-3.32-.42.34-5.4,4.33-8.25,5.05-2.54.65-6,.76-8.12-1a4.65,4.65,0,0,1-.63-6.89c2.75-2.8,9.73-1.61,12.87,0,.24.12,3.29,2.11,4,2.65-1.1-2.43-2.21-4.84-3.41-7.18a82.62,82.62,0,0,0-5.4-9.14c-.2.16-5.37,4.35-8.3,5.09-2.54.64-6,.76-8.12-1a4.64,4.64,0,0,1-.62-6.89c2.75-2.8,9.73-1.61,12.86,0,.25.12,3.53,2.26,4.1,2.69-.12-.17-.22-.35-.34-.52a60.54,60.54,0,0,0-7-8c-1.4-1.38-2.81-2.62-4.21-3.8-.89.88-5,4.85-7.53,5.81s-5.83,1.41-8.18-.08a4.64,4.64,0,0,1-1.38-6.77c2.43-3.09,9.5-2.68,12.79-1.46.18.07,1.92.94,3.18,1.59-.64-.52-1.29-1.07-1.91-1.55-2.34-1.84-4.59-3.38-6.59-4.72-1.15-.75-2.2-1.41-3.19-2-1.32.41-6.65,2-9.31,1.67s-5.83-1.44-7.23-3.84a4.66,4.66,0,0,1,1.9-6.65c3.58-1.62,9.66,2,12,4.6.2.23,3,4.1,2.92,4.12l-.08,0c1,.56,2,1.18,3.1,1.88,2,1.3,4.33,2.79,6.72,4.58a85.54,85.54,0,0,1,7.42,6.14,62.31,62.31,0,0,1,7.24,8,.41.41,0,0,0,.07.11c-.38-1.08-1.34-4.16-1.39-4.4-.66-3.44.09-10.49,3.53-12.38a4.65,4.65,0,0,1,6.46,2.47c1.08,2.56,0,5.81-1.26,8.08-1.48,2.56-6.69,6.29-7.1,6.58a83.54,83.54,0,0,1,5.79,9.32c1,1.88,2,3.8,2.92,5.74-.3-.95-.56-1.8-.58-1.92-.66-3.44.08-10.49,3.53-12.38a4.65,4.65,0,0,1,6.46,2.48c1.08,2.55,0,5.8-1.26,8.07s-5.71,5.57-6.88,6.42c.35.75.71,1.49,1.06,2.24,1.69,3.59,3.35,7.19,5.09,10.67.61,1.22,1.26,2.4,1.9,3.59-.26-.84-.47-1.55-.5-1.67-.66-3.44.09-10.48,3.53-12.37a4.65,4.65,0,0,1,6.46,2.47c1.08,2.55.05,5.81-1.26,8.08s-5.28,5.24-6.67,6.26c.7,1.19,1.39,2.39,2.12,3.52.52.76,1,1.53,1.52,2.26l1.6,2.19c1.07,1.35,2.16,2.76,3.24,4.05.74.91,1.46,1.76,2.19,2.62-.63-1.21-1.8-3.61-1.87-3.82-1.18-3.31-1.51-10.38,1.61-12.77a4.65,4.65,0,0,1,6.76,1.46c1.45,2.36.92,5.74,0,8.18-1,2.69-5.43,7-6,7.54,1.21,1.42,2.39,2.78,3.54,4.06,3.94,4.41,7.39,7.94,9.84,10.38S155,343.69,155,343.69ZM94.67,260.76s4.39-5.33,5.17-8.3c.66-2.53.8-6-.91-8.12a4.65,4.65,0,0,0-6.89-.68c-2.82,2.73-1.68,9.72-.13,12.87C92,256.8,94.62,260.81,94.67,260.76Z"
        style={{
          fill: "#213E60",
          transformOrigin: "110.145px 294.323px",
        }}
        id="el678hytdtot8"
        className="animable"
      />
      <g id="el1evzqs5bs43">
        <path
          d="M155,343.69a1.38,1.38,0,1,1-1.86,2h0s-1.46-1.4-3.87-3.91-5.83-6.16-9.72-10.7c-1.23-1.44-2.51-3-3.82-4.6-.65.37-6,3.43-8.88,3.71-2.61.25-6-.15-7.88-2.19a4.65,4.65,0,0,1,.42-6.9c3.15-2.36,9.87-.12,12.73,1.91.17.12,1.86,1.62,2.9,2.58-.53-.66-1-1.29-1.59-2-1.07-1.35-2.1-2.73-3.21-4.22l-1.55-2.22c-.54-.73-1-1.57-1.52-2.36-1.15-1.86-2.22-3.8-3.25-5.78-1.19.93-5.45,4.19-8,4.84s-6,.76-8.12-1a4.65,4.65,0,0,1-.63-6.89c2.76-2.8,9.74-1.61,12.87,0,.2.1,2.32,1.48,3.47,2.26-.61-1.2-1.23-2.39-1.81-3.62-1.68-3.54-3.27-7.18-4.87-10.81-.49-1.11-1-2.21-1.49-3.32-.42.34-5.4,4.33-8.25,5.05-2.54.65-6,.76-8.12-1a4.65,4.65,0,0,1-.63-6.89c2.75-2.8,9.73-1.61,12.87,0,.24.12,3.29,2.11,4,2.65-1.1-2.43-2.21-4.84-3.41-7.18a82.62,82.62,0,0,0-5.4-9.14c-.2.16-5.37,4.35-8.3,5.09-2.54.64-6,.76-8.12-1a4.64,4.64,0,0,1-.62-6.89c2.75-2.8,9.73-1.61,12.86,0,.25.12,3.53,2.26,4.1,2.69-.12-.17-.22-.35-.34-.52a60.54,60.54,0,0,0-7-8c-1.4-1.38-2.81-2.62-4.21-3.8-.89.88-5,4.85-7.53,5.81s-5.83,1.41-8.18-.08a4.64,4.64,0,0,1-1.38-6.77c2.43-3.09,9.5-2.68,12.79-1.46.18.07,1.92.94,3.18,1.59-.64-.52-1.29-1.07-1.91-1.55-2.34-1.84-4.59-3.38-6.59-4.72-1.15-.75-2.2-1.41-3.19-2-1.32.41-6.65,2-9.31,1.67s-5.83-1.44-7.23-3.84a4.66,4.66,0,0,1,1.9-6.65c3.58-1.62,9.66,2,12,4.6.2.23,3,4.1,2.92,4.12l-.08,0c1,.56,2,1.18,3.1,1.88,2,1.3,4.33,2.79,6.72,4.58a85.54,85.54,0,0,1,7.42,6.14,62.31,62.31,0,0,1,7.24,8,.41.41,0,0,0,.07.11c-.38-1.08-1.34-4.16-1.39-4.4-.66-3.44.09-10.49,3.53-12.38a4.65,4.65,0,0,1,6.46,2.47c1.08,2.56,0,5.81-1.26,8.08-1.48,2.56-6.69,6.29-7.1,6.58a83.54,83.54,0,0,1,5.79,9.32c1,1.88,2,3.8,2.92,5.74-.3-.95-.56-1.8-.58-1.92-.66-3.44.08-10.49,3.53-12.38a4.65,4.65,0,0,1,6.46,2.48c1.08,2.55,0,5.8-1.26,8.07s-5.71,5.57-6.88,6.42c.35.75.71,1.49,1.06,2.24,1.69,3.59,3.35,7.19,5.09,10.67.61,1.22,1.26,2.4,1.9,3.59-.26-.84-.47-1.55-.5-1.67-.66-3.44.09-10.48,3.53-12.37a4.65,4.65,0,0,1,6.46,2.47c1.08,2.55.05,5.81-1.26,8.08s-5.28,5.24-6.67,6.26c.7,1.19,1.39,2.39,2.12,3.52.52.76,1,1.53,1.52,2.26l1.6,2.19c1.07,1.35,2.16,2.76,3.24,4.05.74.91,1.46,1.76,2.19,2.62-.63-1.21-1.8-3.61-1.87-3.82-1.18-3.31-1.51-10.38,1.61-12.77a4.65,4.65,0,0,1,6.76,1.46c1.45,2.36.92,5.74,0,8.18-1,2.69-5.43,7-6,7.54,1.21,1.42,2.39,2.78,3.54,4.06,3.94,4.41,7.39,7.94,9.84,10.38S155,343.69,155,343.69ZM94.67,260.76s4.39-5.33,5.17-8.3c.66-2.53.8-6-.91-8.12a4.65,4.65,0,0,0-6.89-.68c-2.82,2.73-1.68,9.72-.13,12.87C92,256.8,94.62,260.81,94.67,260.76Z"
          style={{
            opacity: 0.1,
            transformOrigin: "110.145px 294.323px",
          }}
          className="animable"
          id="eljrtfny8ltob"
        />
      </g>
      <path
        d="M129.37,409.64c-.85-3.35-2-8.15-3.1-14-.32-1.67-.64-3.46-.94-5.29.74-.18,6.73-1.62,9-3.39,2.07-1.61,4.26-4.23,4.23-7a4.64,4.64,0,0,0-5-4.73c-3.91.44-7.26,6.68-8,10.12,0,.22-.28,2.88-.36,4.24-.19-1.11-.37-2.21-.54-3.37-.25-1.66-.47-3.43-.69-5.14l-.24-2.7c-.11-.92-.09-1.81-.14-2.72,0-1.34,0-2.73,0-4.11,1.71-.16,6.72-.71,8.94-1.95s4.85-3.53,5.23-6.27a4.64,4.64,0,0,0-4.27-5.44c-3.92-.16-8.18,5.5-9.39,8.8,0,.1-.22.82-.42,1.68,0-1.35.11-2.69.21-4.06.3-3.88.72-7.81,1.13-11.76.08-.83.15-1.65.24-2.47,1.44-.13,6.87-.68,9.19-2s4.85-3.53,5.24-6.28a4.65,4.65,0,0,0-4.27-5.44c-3.92-.15-8.19,5.51-9.39,8.8,0,.12-.26,1-.49,1.95.19-2.15.35-4.29.45-6.42a81.67,81.67,0,0,0-.18-11c.51,0,6.89-.56,9.48-2,2.28-1.27,4.85-3.53,5.23-6.28a4.64,4.64,0,0,0-4.27-5.44c-3.92-.15-8.18,5.51-9.39,8.8-.08.23-.84,3.36-1.07,4.49,0,0,0-.09,0-.13a60.31,60.31,0,0,0-2.1-10.57,83.86,83.86,0,0,0-3.21-9.08c-1.12-2.76-2.32-5.22-3.4-7.39-.59-1.17-1.15-2.22-1.69-3.21l.08,0c.07,0-.32-4.73-.38-5-.69-3.44-4-9.68-8-10.13a4.64,4.64,0,0,0-5,4.73c0,2.77,2.15,5.39,4.22,7s7.5,3,8.84,3.36c.54,1,1.1,2.14,1.7,3.37,1,2.19,2.16,4.66,3.22,7.44.29.74.56,1.54.84,2.32-.74-1.21-1.79-2.86-1.91-3-2.19-2.73-8-6.72-11.71-5.32a4.65,4.65,0,0,0-2.3,6.52c1.24,2.48,4.39,3.79,7,4.27s8.23-.81,9.44-1.11c.6,1.73,1.17,3.52,1.66,5.42a58.86,58.86,0,0,1,1.85,10.48c0,.2,0,.42,0,.62-.26-.66-2-4.19-2.12-4.42-1.88-3-7.26-7.57-11.06-6.58a4.64,4.64,0,0,0-3,6.23c1,2.6,4,4.26,6.46,5,2.89.87,9.48-.06,9.73-.09a83.67,83.67,0,0,1-.07,10.61c-.18,2.62-.46,5.26-.77,7.91-.36-.85-2-4.13-2.1-4.35-1.88-3-7.26-7.57-11.06-6.58a4.64,4.64,0,0,0-3,6.23c1,2.6,4,4.25,6.46,5,2.82.84,9.14,0,9.68-.09-.15,1.2-.28,2.41-.43,3.61-.49,3.93-1,7.88-1.39,11.78-.13,1.35-.21,2.69-.3,4-.59-1.26-1.7-3.54-1.82-3.72-1.88-3-7.25-7.57-11-6.58a4.65,4.65,0,0,0-3,6.23c1,2.6,4,4.25,6.46,5s7.85.15,9.35-.05c-.13,2.23-.21,4.45-.18,6.63,0,.95,0,1.91.09,2.81l.18,2.71c.2,1.84.37,3.55.59,5.27.11.86.23,1.67.35,2.51-.41-1.36-1.08-3.52-1.16-3.71-1.42-3.21-6-8.58-9.94-8.18a4.65,4.65,0,0,0-3.91,5.7c.56,2.72,3.26,4.81,5.63,5.93,2.61,1.24,8.77,1.37,9.53,1.38.29,2.06.59,4.05.91,5.92,1,5.89,2,10.77,2.82,14.17s1.32,5.34,1.32,5.34v0a1.38,1.38,0,0,0,2.64-.78S130.22,413,129.37,409.64Z"
        style={{
          fill: "#213E60",
          transformOrigin: "121.34px 350.05px",
        }}
        id="ellfzosgegiae"
        className="animable"
      />
      <path
        d="M121.72,312.72s6.51-2.3,8.7-4.45c1.87-1.84,3.75-4.69,3.4-7.44a4.65,4.65,0,0,0-5.56-4.12c-3.82.89-6.44,7.47-6.73,11C121.5,308,121.65,312.75,121.72,312.72Z"
        style={{
          fill: "#213E60",
          transformOrigin: "127.694px 304.668px",
        }}
        id="elm9yyvgdyptd"
        className="animable"
      />
      <path
        d="M125.62,411.05c-2.55-2.32-6.15-5.7-10.29-9.94-1.19-1.22-2.44-2.53-3.7-3.89.52-.56,4.71-5.07,5.64-7.8.84-2.48,1.22-5.87-.34-8.17a4.64,4.64,0,0,0-6.81-1.16c-3,2.52-2.37,9.58-1.05,12.82.08.21,1.36,2.56,2,3.74-.77-.82-1.53-1.64-2.31-2.52-1.13-1.24-2.28-2.6-3.41-3.9l-1.7-2.12c-.59-.71-1.06-1.46-1.61-2.19-.78-1.09-1.53-2.26-2.28-3.43,1.34-1.07,5.22-4.3,6.39-6.55s2.1-5.62.9-8.12a4.64,4.64,0,0,0-6.56-2.18c-3.36,2-3.79,9.1-3,12.51,0,.12.28.82.58,1.65-.7-1.16-1.4-2.31-2.07-3.51-1.89-3.4-3.71-6.91-5.55-10.43-.38-.73-.77-1.46-1.16-2.19,1.13-.9,5.36-4.36,6.59-6.72s2.09-5.62.9-8.12a4.64,4.64,0,0,0-6.56-2.18c-3.36,2-3.79,9.1-3,12.51,0,.13.33,1,.67,1.9-1-1.9-2.08-3.77-3.17-5.61a83.4,83.4,0,0,0-6.21-9.05c.41-.32,5.45-4.27,6.81-6.89,1.21-2.32,2.1-5.62.9-8.12a4.64,4.64,0,0,0-6.56-2.19c-3.36,2-3.79,9.11-3,12.52.06.24,1.16,3.27,1.58,4.34l-.07-.11a61.72,61.72,0,0,0-7.59-7.65A83.93,83.93,0,0,0,63,332.49c-2.46-1.68-4.82-3.07-6.91-4.28-1.14-.65-2.2-1.22-3.18-1.74l.07,0c.07,0-2.88-3.77-3.1-4-2.47-2.49-8.7-5.84-12.2-4.06a4.64,4.64,0,0,0-1.61,6.72c1.5,2.34,4.77,3.32,7.39,3.52s7.93-1.62,9.22-2.08c1,.56,2.1,1.17,3.28,1.88,2.06,1.25,4.38,2.69,6.79,4.42.65.46,1.32,1,2,1.47-1.28-.6-3.07-1.39-3.25-1.45-3.34-1.07-10.42-1.18-12.71,2a4.66,4.66,0,0,0,1.68,6.71c2.41,1.37,5.76.74,8.17-.29s6.42-5.22,7.27-6.13c1.45,1.11,2.91,2.29,4.37,3.6a59.45,59.45,0,0,1,7.32,7.72c.13.16.24.34.37.51-.59-.41-4-2.4-4.22-2.51-3.2-1.43-10.23-2.32-12.85.61a4.65,4.65,0,0,0,.93,6.85c2.24,1.63,5.65,1.37,8.15.61,2.89-.87,7.88-5.28,8.07-5.44a81.46,81.46,0,0,1,5.8,8.89c1.3,2.28,2.52,4.64,3.72,7-.77-.51-3.91-2.36-4.15-2.47-3.2-1.43-10.23-2.31-12.86.61a4.64,4.64,0,0,0,.94,6.85c2.24,1.64,5.64,1.37,8.15.62,2.82-.86,7.62-5.06,8-5.41.55,1.08,1.1,2.16,1.64,3.24,1.76,3.56,3.5,7.12,5.34,10.59.63,1.2,1.3,2.37,2,3.53-1.19-.73-3.37-2-3.57-2.1-3.2-1.43-10.23-2.31-12.85.61a4.65,4.65,0,0,0,.93,6.85c2.24,1.64,5.64,1.37,8.15.62s6.63-4.21,7.78-5.2c1.12,1.93,2.27,3.83,3.5,5.63.55.77,1.06,1.59,1.62,2.3l1.65,2.15c1.18,1.43,2.27,2.77,3.4,4.07l1.67,1.91c-1.09-.92-2.84-2.34-3-2.45-3-1.9-9.76-3.84-12.8-1.35a4.65,4.65,0,0,0-.12,6.92c2,1.95,5.38,2.21,8,1.84,2.86-.41,8.07-3.7,8.71-4.11,1.37,1.55,2.73,3,4,4.43,4.08,4.37,7.65,7.86,10.18,10.26s4,3.74,4,3.74h0a1.38,1.38,0,0,0,1.77-2.11S128.18,413.38,125.62,411.05Z"
        style={{
          fill: "#213E60",
          transformOrigin: "82.6614px 367.438px",
        }}
        id="eld2q5cf90y0s"
        className="animable"
      />
      <path
        d="M65.78,334.44s4.15-5.51,4.8-8.52c.55-2.56.54-6-1.27-8.08a4.66,4.66,0,0,0-6.91-.37c-2.7,2.85-1.25,9.79.43,12.86C63,330.6,65.73,334.49,65.78,334.44Z"
        style={{
          fill: "#213E60",
          transformOrigin: "65.8998px 325.276px",
        }}
        id="elqz2v5hlko5q"
        className="animable"
      />
      <g id="el2oy2hvuu518">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "87.919px 350.351px",
          }}
          className="animable"
          id="eludxsqm6ou1"
        >
          <path
            d="M129.37,409.64c-.85-3.35-2-8.15-3.1-14-.32-1.67-.64-3.46-.94-5.29.74-.18,6.73-1.62,9-3.39,2.07-1.61,4.26-4.23,4.23-7a4.64,4.64,0,0,0-5-4.73c-3.91.44-7.26,6.68-8,10.12,0,.22-.28,2.88-.36,4.24-.19-1.11-.37-2.21-.54-3.37-.25-1.66-.47-3.43-.69-5.14l-.24-2.7c-.11-.92-.09-1.81-.14-2.72,0-1.34,0-2.73,0-4.11,1.71-.16,6.72-.71,8.94-1.95s4.85-3.53,5.23-6.27a4.64,4.64,0,0,0-4.27-5.44c-3.92-.16-8.18,5.5-9.39,8.8,0,.1-.22.82-.42,1.68,0-1.35.11-2.69.21-4.06.3-3.88.72-7.81,1.13-11.76.08-.83.15-1.65.24-2.47,1.44-.13,6.87-.68,9.19-2s4.85-3.53,5.24-6.28a4.65,4.65,0,0,0-4.27-5.44c-3.92-.15-8.19,5.51-9.39,8.8,0,.12-.26,1-.49,1.95.19-2.15.35-4.29.45-6.42a81.67,81.67,0,0,0-.18-11c.51,0,6.89-.56,9.48-2,2.28-1.27,4.85-3.53,5.23-6.28a4.64,4.64,0,0,0-4.27-5.44c-3.92-.15-8.18,5.51-9.39,8.8-.08.23-.84,3.36-1.07,4.49,0,0,0-.09,0-.13a60.31,60.31,0,0,0-2.1-10.57,83.86,83.86,0,0,0-3.21-9.08c-1.12-2.76-2.32-5.22-3.4-7.39-.59-1.17-1.15-2.22-1.69-3.21l.08,0c.07,0-.32-4.73-.38-5-.69-3.44-4-9.68-8-10.13a4.64,4.64,0,0,0-5,4.73c0,2.77,2.15,5.39,4.22,7s7.5,3,8.84,3.36c.54,1,1.1,2.14,1.7,3.37,1,2.19,2.16,4.66,3.22,7.44.29.74.56,1.54.84,2.32-.74-1.21-1.79-2.86-1.91-3-2.19-2.73-8-6.72-11.71-5.32a4.65,4.65,0,0,0-2.3,6.52c1.24,2.48,4.39,3.79,7,4.27s8.23-.81,9.44-1.11c.6,1.73,1.17,3.52,1.66,5.42a58.86,58.86,0,0,1,1.85,10.48c0,.2,0,.42,0,.62-.26-.66-2-4.19-2.12-4.42-1.88-3-7.26-7.57-11.06-6.58a4.64,4.64,0,0,0-3,6.23c1,2.6,4,4.26,6.46,5,2.89.87,9.48-.06,9.73-.09a83.67,83.67,0,0,1-.07,10.61c-.18,2.62-.46,5.26-.77,7.91-.36-.85-2-4.13-2.1-4.35-1.88-3-7.26-7.57-11.06-6.58a4.64,4.64,0,0,0-3,6.23c1,2.6,4,4.25,6.46,5,2.82.84,9.14,0,9.68-.09-.15,1.2-.28,2.41-.43,3.61-.49,3.93-1,7.88-1.39,11.78-.13,1.35-.21,2.69-.3,4-.59-1.26-1.7-3.54-1.82-3.72-1.88-3-7.25-7.57-11-6.58a4.65,4.65,0,0,0-3,6.23c1,2.6,4,4.25,6.46,5s7.85.15,9.35-.05c-.13,2.23-.21,4.45-.18,6.63,0,.95,0,1.91.09,2.81l.18,2.71c.2,1.84.37,3.55.59,5.27.11.86.23,1.67.35,2.51-.41-1.36-1.08-3.52-1.16-3.71-1.42-3.21-6-8.58-9.94-8.18a4.65,4.65,0,0,0-3.91,5.7c.56,2.72,3.26,4.81,5.63,5.93,2.61,1.24,8.77,1.37,9.53,1.38.29,2.06.59,4.05.91,5.92,1,5.89,2,10.77,2.82,14.17s1.32,5.34,1.32,5.34v0a1.38,1.38,0,0,0,2.64-.78S130.22,413,129.37,409.64Z"
            id="eltq0cd2jbmb"
            className="animable"
            style={{
              transformOrigin: "121.34px 350.05px",
            }}
          />
          <path
            d="M121.72,312.72s6.51-2.3,8.7-4.45c1.87-1.84,3.75-4.69,3.4-7.44a4.65,4.65,0,0,0-5.56-4.12c-3.82.89-6.44,7.47-6.73,11C121.5,308,121.65,312.75,121.72,312.72Z"
            id="elfzlob9eugb"
            className="animable"
            style={{
              transformOrigin: "127.694px 304.668px",
            }}
          />
          <path
            d="M125.62,411.05c-2.55-2.32-6.15-5.7-10.29-9.94-1.19-1.22-2.44-2.53-3.7-3.89.52-.56,4.71-5.07,5.64-7.8.84-2.48,1.22-5.87-.34-8.17a4.64,4.64,0,0,0-6.81-1.16c-3,2.52-2.37,9.58-1.05,12.82.08.21,1.36,2.56,2,3.74-.77-.82-1.53-1.64-2.31-2.52-1.13-1.24-2.28-2.6-3.41-3.9l-1.7-2.12c-.59-.71-1.06-1.46-1.61-2.19-.78-1.09-1.53-2.26-2.28-3.43,1.34-1.07,5.22-4.3,6.39-6.55s2.1-5.62.9-8.12a4.64,4.64,0,0,0-6.56-2.18c-3.36,2-3.79,9.1-3,12.51,0,.12.28.82.58,1.65-.7-1.16-1.4-2.31-2.07-3.51-1.89-3.4-3.71-6.91-5.55-10.43-.38-.73-.77-1.46-1.16-2.19,1.13-.9,5.36-4.36,6.59-6.72s2.09-5.62.9-8.12a4.64,4.64,0,0,0-6.56-2.18c-3.36,2-3.79,9.1-3,12.51,0,.13.33,1,.67,1.9-1-1.9-2.08-3.77-3.17-5.61a83.4,83.4,0,0,0-6.21-9.05c.41-.32,5.45-4.27,6.81-6.89,1.21-2.32,2.1-5.62.9-8.12a4.64,4.64,0,0,0-6.56-2.19c-3.36,2-3.79,9.11-3,12.52.06.24,1.16,3.27,1.58,4.34l-.07-.11a61.72,61.72,0,0,0-7.59-7.65A83.93,83.93,0,0,0,63,332.49c-2.46-1.68-4.82-3.07-6.91-4.28-1.14-.65-2.2-1.22-3.18-1.74l.07,0c.07,0-2.88-3.77-3.1-4-2.47-2.49-8.7-5.84-12.2-4.06a4.64,4.64,0,0,0-1.61,6.72c1.5,2.34,4.77,3.32,7.39,3.52s7.93-1.62,9.22-2.08c1,.56,2.1,1.17,3.28,1.88,2.06,1.25,4.38,2.69,6.79,4.42.65.46,1.32,1,2,1.47-1.28-.6-3.07-1.39-3.25-1.45-3.34-1.07-10.42-1.18-12.71,2a4.66,4.66,0,0,0,1.68,6.71c2.41,1.37,5.76.74,8.17-.29s6.42-5.22,7.27-6.13c1.45,1.11,2.91,2.29,4.37,3.6a59.45,59.45,0,0,1,7.32,7.72c.13.16.24.34.37.51-.59-.41-4-2.4-4.22-2.51-3.2-1.43-10.23-2.32-12.85.61a4.65,4.65,0,0,0,.93,6.85c2.24,1.63,5.65,1.37,8.15.61,2.89-.87,7.88-5.28,8.07-5.44a81.46,81.46,0,0,1,5.8,8.89c1.3,2.28,2.52,4.64,3.72,7-.77-.51-3.91-2.36-4.15-2.47-3.2-1.43-10.23-2.31-12.86.61a4.64,4.64,0,0,0,.94,6.85c2.24,1.64,5.64,1.37,8.15.62,2.82-.86,7.62-5.06,8-5.41.55,1.08,1.1,2.16,1.64,3.24,1.76,3.56,3.5,7.12,5.34,10.59.63,1.2,1.3,2.37,2,3.53-1.19-.73-3.37-2-3.57-2.1-3.2-1.43-10.23-2.31-12.85.61a4.65,4.65,0,0,0,.93,6.85c2.24,1.64,5.64,1.37,8.15.62s6.63-4.21,7.78-5.2c1.12,1.93,2.27,3.83,3.5,5.63.55.77,1.06,1.59,1.62,2.3l1.65,2.15c1.18,1.43,2.27,2.77,3.4,4.07l1.67,1.91c-1.09-.92-2.84-2.34-3-2.45-3-1.9-9.76-3.84-12.8-1.35a4.65,4.65,0,0,0-.12,6.92c2,1.95,5.38,2.21,8,1.84,2.86-.41,8.07-3.7,8.71-4.11,1.37,1.55,2.73,3,4,4.43,4.08,4.37,7.65,7.86,10.18,10.26s4,3.74,4,3.74h0a1.38,1.38,0,0,0,1.77-2.11S128.18,413.38,125.62,411.05Z"
            id="el0rees6ca9ly"
            className="animable"
            style={{
              transformOrigin: "82.6614px 367.438px",
            }}
          />
          <path
            d="M65.78,334.44s4.15-5.51,4.8-8.52c.55-2.56.54-6-1.27-8.08a4.66,4.66,0,0,0-6.91-.37c-2.7,2.85-1.25,9.79.43,12.86C63,330.6,65.73,334.49,65.78,334.44Z"
            id="eljk6rbx1erx"
            className="animable"
            style={{
              transformOrigin: "65.8998px 325.276px",
            }}
          />
        </g>
      </g>
      <g id="elnjxcvc40cjp">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "151.551px 276.891px",
          }}
          className="animable"
          id="elwq15wrv2ngi"
        >
          <path
            d="M154.88,336.69c-.7-3.38-1.63-8.23-2.48-14.09-.25-1.69-.49-3.48-.71-5.33.76-.14,6.8-1.32,9.15-3,2.14-1.51,4.44-4,4.53-6.8a4.64,4.64,0,0,0-4.83-5c-3.92.27-7.54,6.35-8.39,9.76-.05.22-.4,2.86-.55,4.22-.13-1.12-.26-2.23-.38-3.39-.18-1.68-.32-3.45-.46-5.17,0-.9-.09-1.8-.13-2.71s0-1.8,0-2.72c0-1.34.1-2.73.17-4.11,1.72-.08,6.75-.41,9-1.55s5-3.31,5.51-6a4.66,4.66,0,0,0-4-5.63c-3.91-.32-8.42,5.14-9.76,8.38-.05.1-.26.82-.51,1.67.12-1.35.23-2.7.4-4.06.46-3.85,1.06-7.77,1.64-11.7.12-.82.23-1.63.35-2.45,1.44-.07,6.9-.37,9.27-1.56s5-3.32,5.51-6a4.65,4.65,0,0,0-4-5.63c-3.92-.32-8.42,5.14-9.77,8.38,0,.11-.3,1-.58,1.92.29-2.13.54-4.27.73-6.39a81.19,81.19,0,0,0,.31-11c.51,0,6.91-.25,9.55-1.57,2.35-1.17,5-3.31,5.51-6a4.64,4.64,0,0,0-4-5.62c-3.92-.33-8.42,5.14-9.77,8.37-.1.23-1,3.33-1.27,4.44a.57.57,0,0,1,0-.13,61,61,0,0,0-1.64-10.65,83.36,83.36,0,0,0-2.8-9.22c-1-2.8-2.09-5.31-3.07-7.52-.54-1.2-1.06-2.28-1.55-3.28l.08,0c.07,0-.12-4.75-.16-5-.54-3.46-3.61-9.84-7.49-10.46a4.64,4.64,0,0,0-5.25,4.5c-.16,2.77,1.91,5.48,3.9,7.18s7.37,3.36,8.69,3.74c.49,1.06,1,2.19,1.55,3.45.93,2.23,2,4.75,2.89,7.57.25.75.49,1.57.74,2.35-.69-1.24-1.66-2.93-1.78-3.08-2.07-2.83-7.74-7.08-11.46-5.84a4.64,4.64,0,0,0-2.59,6.41c1.13,2.53,4.22,4,6.78,4.57s8.26-.44,9.48-.68c.52,1.75,1,3.56,1.42,5.48A59.71,59.71,0,0,1,154,256.23c0,.21,0,.42,0,.63-.24-.68-1.8-4.27-1.93-4.51-1.75-3-6.92-7.89-10.76-7.07a4.65,4.65,0,0,0-3.28,6.1c.85,2.63,3.77,4.42,6.24,5.28,2.85,1,9.48.36,9.72.34a81.27,81.27,0,0,1-.53,10.6c-.29,2.61-.69,5.24-1.12,7.87-.33-.87-1.77-4.21-1.91-4.44-1.74-3-6.91-7.88-10.75-7.06a4.65,4.65,0,0,0-3.28,6.09c.85,2.64,3.76,4.42,6.24,5.29,2.78,1,9.13.39,9.67.34-.2,1.19-.39,2.39-.59,3.59-.67,3.9-1.35,7.82-1.9,11.7-.2,1.35-.34,2.68-.48,4-.53-1.29-1.54-3.61-1.65-3.8-1.75-3-6.92-7.89-10.76-7.06a4.65,4.65,0,0,0-3.28,6.09c.85,2.64,3.76,4.42,6.24,5.29s7.83.49,9.34.37c-.23,2.22-.4,4.43-.47,6.61,0,.94-.09,1.91,0,2.81s0,1.82.06,2.71c.12,1.85.21,3.57.36,5.29.07.87.15,1.69.23,2.53-.34-1.38-.92-3.57-1-3.76-1.27-3.27-5.64-8.84-9.57-8.61a4.66,4.66,0,0,0-4.16,5.53c.44,2.73,3,4.94,5.36,6.17,2.56,1.35,8.71,1.75,9.46,1.8.2,2.06.42,4.07.65,5.94.74,5.94,1.57,10.85,2.2,14.29s1.08,5.39,1.08,5.39v0a1.38,1.38,0,1,0,2.67-.66S155.58,340.08,154.88,336.69Z"
            id="elxztq2nzh4oj"
            className="animable"
            style={{
              transformOrigin: "151.551px 276.891px",
            }}
          />
          <path
            d="M151.52,239.53s6.6-2,8.89-4.07c2-1.74,4-4.51,3.71-7.28a4.64,4.64,0,0,0-5.36-4.36c-3.86.72-6.77,7.18-7.21,10.66C151.51,234.78,151.45,239.55,151.52,239.53Z"
            id="elt0nmitqosiq"
            className="animable"
            style={{
              transformOrigin: "157.818px 231.647px",
            }}
          />
        </g>
      </g>
      <path
        d="M366.37,361.64c.13,31.33,25.06,56.63,25.06,56.63s24.72-25.51,24.58-56.84S391,304.8,391,304.8,366.23,330.31,366.37,361.64Z"
        style={{
          fill: "#213E60",
          transformOrigin: "391.19px 361.535px",
        }}
        id="el1lkp77gy26g"
        className="animable"
      />
      <line
        x1={391.43}
        y1={418.27}
        x2={390.95}
        y2={304.8}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "391.19px 361.535px",
        }}
        id="eld9fxeulrgcb"
        className="animable"
      />
      <line
        x1={391.12}
        y1={345.13}
        x2={377.17}
        y2={333.06}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "384.145px 339.095px",
        }}
        id="elfpomq0cwghl"
        className="animable"
      />
      <line
        x1={391.42}
        y1={363.88}
        x2={408.52}
        y2={338.88}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "399.97px 351.38px",
        }}
        id="el1u93w3catzt"
        className="animable"
      />
      <line
        x1={391.25}
        y1={374.69}
        x2={370.65}
        y2={356.47}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "380.95px 365.58px",
        }}
        id="elttp3721vkph"
        className="animable"
      />
      <line
        x1={391.53}
        y1={389.25}
        x2={411.75}
        y2={371.07}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "401.64px 380.16px",
        }}
        id="elbzhlffvy72t"
        className="animable"
      />
      <line
        x1={391.58}
        y1={401.82}
        x2={375.65}
        y2={389.32}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "383.615px 395.57px",
        }}
        id="elvc6lz1072cg"
        className="animable"
      />
      <path
        d="M349.38,410C361.49,423.58,382,425,382,425s.91-20.57-11.2-34.11-32.66-14.92-32.66-14.92S337.27,396.5,349.38,410Z"
        style={{
          fill: "#213E60",
          transformOrigin: "360.071px 400.485px",
        }}
        id="elvi3p18ijax9"
        className="animable"
      />
      <line
        x1={382.04}
        y1={424.96}
        x2={338.18}
        y2={375.93}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "360.11px 400.445px",
        }}
        id="el3u4e4jl44i"
        className="animable"
      />
      <line
        x1={353.77}
        y1={393.35}
        x2={343.07}
        y2={393.48}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "348.42px 393.415px",
        }}
        id="elq9acekqi16"
        className="animable"
      />
      <line
        x1={361.11}
        y1={401.37}
        x2={358.91}
        y2={383.95}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "360.01px 392.66px",
        }}
        id="el6v2ggkct2zw"
        className="animable"
      />
      <line
        x1={365.19}
        y1={406.13}
        x2={349.25}
        y2={406.15}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "357.22px 406.14px",
        }}
        id="elx1exvkri85s"
        className="animable"
      />
      <line
        x1={370.92}
        y1={412.33}
        x2={372.7}
        y2={396.67}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "371.81px 404.5px",
        }}
        id="ela3kpkkxhs1q"
        className="animable"
      />
      <line
        x1={375.78}
        y1={417.77}
        x2={364.06}
        y2={418.47}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "369.92px 418.12px",
        }}
        id="ela4e4fc612kp"
        className="animable"
      />
      <path
        d="M412.54,390.19c-12.6,13.09-12.44,33.68-12.44,33.68s20.58-.63,33.18-13.72,12.44-33.68,12.44-33.68S425.14,377.1,412.54,390.19Z"
        style={{
          fill: "#213E60",
          transformOrigin: "422.91px 400.17px",
        }}
        id="ela57iaifcz3l"
        className="animable"
      />
      <line
        x1={400.1}
        y1={423.87}
        x2={445.72}
        y2={376.47}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "422.91px 400.17px",
        }}
        id="el2gbwc7kjf02"
        className="animable"
      />
      <line
        x1={429.51}
        y1={393.32}
        x2={428.58}
        y2={382.66}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "429.045px 387.99px",
        }}
        id="el2rjar48vz1l"
        className="animable"
      />
      <line
        x1={422.06}
        y1={401.24}
        x2={439.27}
        y2={397.75}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "430.665px 399.495px",
        }}
        id="ell239fvcpsz"
        className="animable"
      />
      <line
        x1={417.62}
        y1={405.67}
        x2={416.41}
        y2={389.77}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "417.015px 397.72px",
        }}
        id="elj7td237jj7p"
        className="animable"
      />
      <line
        x1={411.86}
        y1={411.84}
        x2={427.61}
        y2={412.44}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "419.735px 412.14px",
        }}
        id="elzcwxu3gft1s"
        className="animable"
      />
      <line
        x1={406.8}
        y1={417.09}
        x2={405.22}
        y2={405.45}
        style={{
          fill: "#213E60",
          stroke: "rgb(255, 255, 255)",
          strokeMiterlimit: 10,
          strokeWidth: "0.910297px",
          transformOrigin: "406.01px 411.27px",
        }}
        id="elqvd56nsd8"
        className="animable"
      />
      <g id="elhgk9fk15uxb">
        <g
          style={{
            opacity: 0.1,
            transformOrigin: "391.923px 364.9px",
          }}
          className="animable"
          id="el34ygcchjoqj"
        >
          <path
            d="M366.37,361.64c.13,31.33,25.06,56.63,25.06,56.63s24.72-25.51,24.58-56.84S391,304.8,391,304.8,366.23,330.31,366.37,361.64Z"
            id="elk0njnsm1m8q"
            className="animable"
            style={{
              transformOrigin: "391.19px 361.535px",
            }}
          />
          <line
            x1={391.43}
            y1={418.27}
            x2={390.95}
            y2={304.8}
            id="el7ur4nvr65xr"
            className="animable"
            style={{
              transformOrigin: "391.19px 361.535px",
            }}
          />
          <line
            x1={391.12}
            y1={345.13}
            x2={377.17}
            y2={333.06}
            id="elpxbwh6m3j8i"
            className="animable"
            style={{
              transformOrigin: "384.145px 339.095px",
            }}
          />
          <line
            x1={391.42}
            y1={363.88}
            x2={408.52}
            y2={338.88}
            id="elz4qs7d7x6q"
            className="animable"
            style={{
              transformOrigin: "399.97px 351.38px",
            }}
          />
          <line
            x1={391.25}
            y1={374.69}
            x2={370.65}
            y2={356.47}
            id="el4g8yppgfeww"
            className="animable"
            style={{
              transformOrigin: "380.95px 365.58px",
            }}
          />
          <line
            x1={391.53}
            y1={389.25}
            x2={411.75}
            y2={371.07}
            id="eloqwbb2x04r9"
            className="animable"
            style={{
              transformOrigin: "401.64px 380.16px",
            }}
          />
          <line
            x1={391.58}
            y1={401.82}
            x2={375.65}
            y2={389.32}
            id="elfomqpo636w"
            className="animable"
            style={{
              transformOrigin: "383.615px 395.57px",
            }}
          />
          <path
            d="M349.38,410C361.49,423.58,382,425,382,425s.91-20.57-11.2-34.11-32.66-14.92-32.66-14.92S337.27,396.5,349.38,410Z"
            id="elf1peylewxbm"
            className="animable"
            style={{
              transformOrigin: "360.071px 400.485px",
            }}
          />
          <line
            x1={382.04}
            y1={424.96}
            x2={338.18}
            y2={375.93}
            id="elote5ftgv5vm"
            className="animable"
            style={{
              transformOrigin: "360.11px 400.445px",
            }}
          />
          <line
            x1={353.77}
            y1={393.35}
            x2={343.07}
            y2={393.48}
            id="el0bnasm0i9sbd"
            className="animable"
            style={{
              transformOrigin: "348.42px 393.415px",
            }}
          />
          <line
            x1={361.11}
            y1={401.37}
            x2={358.91}
            y2={383.95}
            id="el2fvushr38c4"
            className="animable"
            style={{
              transformOrigin: "360.01px 392.66px",
            }}
          />
          <line
            x1={365.19}
            y1={406.13}
            x2={349.25}
            y2={406.15}
            id="eliy8gk4vt4ts"
            className="animable"
            style={{
              transformOrigin: "357.22px 406.14px",
            }}
          />
          <line
            x1={370.92}
            y1={412.33}
            x2={372.7}
            y2={396.67}
            id="el9je0ia00kpq"
            className="animable"
            style={{
              transformOrigin: "371.81px 404.5px",
            }}
          />
          <line
            x1={375.78}
            y1={417.77}
            x2={364.06}
            y2={418.47}
            id="elebytj2in3w5"
            className="animable"
            style={{
              transformOrigin: "369.92px 418.12px",
            }}
          />
          <path
            d="M412.54,390.19c-12.6,13.09-12.44,33.68-12.44,33.68s20.58-.63,33.18-13.72,12.44-33.68,12.44-33.68S425.14,377.1,412.54,390.19Z"
            id="elk3vefpny2p"
            className="animable"
            style={{
              transformOrigin: "422.91px 400.17px",
            }}
          />
          <line
            x1={400.1}
            y1={423.87}
            x2={445.72}
            y2={376.47}
            id="ely9w6fqaxhp"
            className="animable"
            style={{
              transformOrigin: "422.91px 400.17px",
            }}
          />
          <line
            x1={429.51}
            y1={393.32}
            x2={428.58}
            y2={382.66}
            id="el4s7izwkv20t"
            className="animable"
            style={{
              transformOrigin: "429.045px 387.99px",
            }}
          />
          <line
            x1={422.06}
            y1={401.24}
            x2={439.27}
            y2={397.75}
            id="elda6cfpp66ll"
            className="animable"
            style={{
              transformOrigin: "430.665px 399.495px",
            }}
          />
          <line
            x1={417.62}
            y1={405.67}
            x2={416.41}
            y2={389.77}
            id="elyeok4bk8fgd"
            className="animable"
            style={{
              transformOrigin: "417.015px 397.72px",
            }}
          />
          <line
            x1={411.86}
            y1={411.84}
            x2={427.61}
            y2={412.44}
            id="elpa2wpkvxr5"
            className="animable"
            style={{
              transformOrigin: "419.735px 412.14px",
            }}
          />
          <line
            x1={406.8}
            y1={417.09}
            x2={405.22}
            y2={405.45}
            id="elwruryoxcmmn"
            className="animable"
            style={{
              transformOrigin: "406.01px 411.27px",
            }}
          />
        </g>
      </g>
    </g>
    <g
      id="freepik--Resume--inject-7"
      className="animable animator-active"
      style={{
        transformOrigin: "250.13px 264.535px",
      }}
    >
      <rect
        x={126.79}
        y={105.78}
        width={246.68}
        height={317.51}
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "250.13px 264.535px",
        }}
        id="elgq3yk09xmrl"
        className="animable"
      />
      <rect
        x={126.79}
        y={105.78}
        width={39.35}
        height={317.51}
        style={{
          fill: "#213E60",
          mixBlendMode: "multiply",
          transformOrigin: "146.465px 264.535px",
        }}
        id="el3q0c6tvxwkk"
        className="animable"
      />
      <rect
        x={243.01}
        y={152.69}
        width={75.65}
        height={8.9}
        style={{
          fill: "#213E60",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "280.835px 157.14px",
        }}
        id="elu9iyc6keits"
        className="animable"
      />
      <rect
        x={157.83}
        y={228.52}
        width={207.37}
        height={8.9}
        style={{
          fill: "#213E60",
          transformOrigin: "261.515px 232.97px",
        }}
        id="elmoxs85lzuch"
        className="animable"
      />
      <rect
        x={157.83}
        y={350.84}
        width={207.37}
        height={8.9}
        style={{
          fill: "#213E60",
          transformOrigin: "261.515px 355.29px",
        }}
        id="elpdrrfq7wevm"
        className="animable"
      />
      <rect
        x={243.01}
        y={168.02}
        width={47.68}
        height={8.9}
        style={{
          fill: "#213E60",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "266.85px 172.47px",
        }}
        id="eliu130bn16q"
        className="animable"
      />
      <rect
        x={243.01}
        y={183.03}
        width={47.68}
        height={8.9}
        style={{
          fill: "#213E60",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "266.85px 187.48px",
        }}
        id="ellnbuar7sfe"
        className="animable"
      />
      <rect
        x={231.54}
        y={247.22}
        width={4.91}
        height={4.91}
        style={{
          fill: "#213E60",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "233.995px 249.675px",
        }}
        id="elprdq42scv2r"
        className="animable"
      />
      <rect
        x={231.54}
        y={310.37}
        width={4.91}
        height={4.91}
        style={{
          fill: "#213E60",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "233.995px 312.825px",
        }}
        id="ell9slj0ta0y8"
        className="animable"
      />
      <rect
        x={300.83}
        y={247.22}
        width={4.91}
        height={4.91}
        style={{
          fill: "#213E60",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "303.285px 249.675px",
        }}
        id="elto0sjpru47q"
        className="animable"
      />
      <rect
        x={300.83}
        y={310.37}
        width={4.91}
        height={4.91}
        style={{
          fill: "#213E60",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "303.285px 312.825px",
        }}
        id="ely1obcj2qqx"
        className="animable"
      />
      <rect
        x={126.79}
        y={105.78}
        width={246.68}
        height={16.15}
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "250.13px 113.855px",
        }}
        id="elfq6euz9tbtl"
        className="animable"
      />
      <path
        d="M287.83,250.63H244.41a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,287.83,250.63Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "266.12px 249.23px",
        }}
        id="el7axl9tjdf49"
        className="animable"
      />
      <path
        d="M287.83,257.64H244.41a1.41,1.41,0,0,1-1.4-1.41h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.41,1.41,0,0,1,287.83,257.64Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "266.12px 256.235px",
        }}
        id="ele582zpy38fa"
        className="animable"
      />
      <path
        d="M287.83,264.64H244.41a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,287.83,264.64Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "266.12px 263.24px",
        }}
        id="elbhwk7yoqsn"
        className="animable"
      />
      <path
        d="M287.83,271.64H244.41a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,287.83,271.64Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "266.12px 270.24px",
        }}
        id="el25pa0w6okq2"
        className="animable"
      />
      <path
        d="M287.83,278.64H244.41a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,287.83,278.64Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "266.12px 277.24px",
        }}
        id="elz2uo2so3azp"
        className="animable"
      />
      <path
        d="M353.51,250.63H310.09a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,353.51,250.63Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 249.23px",
        }}
        id="elu99e89faaqn"
        className="animable"
      />
      <path
        d="M353.51,257.64H310.09a1.41,1.41,0,0,1-1.4-1.41h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.41,1.41,0,0,1,353.51,257.64Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 256.235px",
        }}
        id="eltepkcgrp60c"
        className="animable"
      />
      <path
        d="M353.51,264.64H310.09a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,353.51,264.64Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 263.24px",
        }}
        id="elwa21e017mm"
        className="animable"
      />
      <path
        d="M353.51,271.64H310.09a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,353.51,271.64Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 270.24px",
        }}
        id="elrung6yvb3ts"
        className="animable"
      />
      <path
        d="M353.51,278.64H310.09a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,353.51,278.64Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 277.24px",
        }}
        id="el51btgb1dazu"
        className="animable"
      />
      <path
        d="M287.83,312.73H244.41a1.41,1.41,0,0,1-1.4-1.41h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.41,1.41,0,0,1,287.83,312.73Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "266.12px 311.325px",
        }}
        id="elgxio2now4c"
        className="animable"
      />
      <path
        d="M287.83,319.73H244.41a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,287.83,319.73Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "266.12px 318.33px",
        }}
        id="el6lr80ygczed"
        className="animable"
      />
      <path
        d="M287.83,326.73H244.41a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,287.83,326.73Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "266.12px 325.33px",
        }}
        id="el04x6gm9jfd5x"
        className="animable"
      />
      <path
        d="M287.83,333.73H244.41a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,287.83,333.73Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "266.12px 332.33px",
        }}
        id="elqulrtrmr82"
        className="animable"
      />
      <path
        d="M287.83,340.74H244.41a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,287.83,340.74Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "266.12px 339.34px",
        }}
        id="el8d8un6modx"
        className="animable"
      />
      <path
        d="M353.51,312.73H310.09a1.41,1.41,0,0,1-1.4-1.41h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.41,1.41,0,0,1,353.51,312.73Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 311.325px",
        }}
        id="elqzbs9ge56g"
        className="animable"
      />
      <path
        d="M353.51,319.73H310.09a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,353.51,319.73Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 318.33px",
        }}
        id="elniwsdpq079l"
        className="animable"
      />
      <path
        d="M353.51,326.73H310.09a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,353.51,326.73Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 325.33px",
        }}
        id="elzxxod21aqpn"
        className="animable"
      />
      <path
        d="M353.51,333.73H310.09a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,353.51,333.73Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 332.33px",
        }}
        id="elbhp7xb2p6ar"
        className="animable"
      />
      <path
        d="M353.51,340.74H310.09a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,353.51,340.74Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 339.34px",
        }}
        id="elhmhhesiyo8t"
        className="animable"
      />
      <path
        d="M353.51,372.7H310.09a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,353.51,372.7Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 371.3px",
        }}
        id="elhcnd4vpfq4l"
        className="animable"
      />
      <path
        d="M353.51,379.7H310.09a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,353.51,379.7Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 378.3px",
        }}
        id="elksi88a8e948"
        className="animable"
      />
      <path
        d="M353.51,386.71H310.09a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,353.51,386.71Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 385.31px",
        }}
        id="elz87as5ryd7"
        className="animable"
      />
      <rect
        x={308.69}
        y={390.91}
        width={46.22}
        height={2.8}
        rx={1.4}
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 392.31px",
        }}
        id="eluuqaxbtnrg"
        className="animable"
      />
      <path
        d="M353.51,400.71H310.09a1.4,1.4,0,0,1-1.4-1.4h0a1.4,1.4,0,0,1,1.4-1.4h43.42a1.4,1.4,0,0,1,1.4,1.4h0A1.4,1.4,0,0,1,353.51,400.71Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "331.8px 399.31px",
        }}
        id="elxl5y16ourer"
        className="animable"
      />
      <path
        d="M349.31,291.25a5.6,5.6,0,0,0-5.52,4.67h-6.7a5.6,5.6,0,0,0-11,0h-6.7a5.6,5.6,0,0,0-11,0H301.6a5.59,5.59,0,0,0-11,0h-6.71a5.59,5.59,0,0,0-11,0h-6.71a5.59,5.59,0,0,0-11,0h-6.71a5.6,5.6,0,1,0,0,1.87h6.71a5.59,5.59,0,0,0,11,0h6.71a5.59,5.59,0,0,0,11,0h6.71a5.59,5.59,0,0,0,11,0h6.71a5.6,5.6,0,0,0,11,0h6.7a5.6,5.6,0,0,0,11,0h6.7a5.6,5.6,0,1,0,5.52-6.54Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "296.09px 296.853px",
        }}
        id="elmd7lbzkhqfa"
        className="animable"
      />
      <path
        d="M218.69,370.42a9.44,9.44,0,1,0,9.43,9.44A9.43,9.43,0,0,0,218.69,370.42Zm0,14.14a4.71,4.71,0,1,1,4.7-4.7A4.71,4.71,0,0,1,218.69,384.56Z"
        style={{
          fill: "#213E60",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "218.68px 379.86px",
        }}
        id="el57p1tr9dm1q"
        className="animable"
      />
      <path
        d="M221.5,383.61,226,385.8a9.43,9.43,0,0,0-7.28-15.38v4.73a4.7,4.7,0,0,1,2.77,8.46Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "223.417px 378.11px",
        }}
        id="el9od7m7m5u3p"
        className="animable"
      />
      <path
        d="M223.23,401h-9a2.24,2.24,0,0,1-2.25-2.24h0a2.25,2.25,0,0,1,2.25-2.25h9a2.25,2.25,0,0,1,2.25,2.25h0A2.24,2.24,0,0,1,223.23,401Z"
        style={{
          fill: "#213E60",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "218.73px 398.755px",
        }}
        id="el1lwfbgpkc4c"
        className="animable"
      />
      <path
        d="M246.82,370.42a9.44,9.44,0,1,0,9.44,9.44A9.43,9.43,0,0,0,246.82,370.42Zm0,14.14a4.71,4.71,0,1,1,4.71-4.7A4.7,4.7,0,0,1,246.82,384.56Z"
        style={{
          fill: "#213E60",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "246.82px 379.86px",
        }}
        id="el4axn4vplzft"
        className="animable"
      />
      <path
        d="M256.21,378.87a9.46,9.46,0,0,0-9.34-8.45v4.73a4.71,4.71,0,0,1,4.66,4.71,5,5,0,0,1-.06.54Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "251.54px 375.41px",
        }}
        id="elwx9dj17gdb"
        className="animable"
      />
      <path
        d="M251.32,401h-9a2.24,2.24,0,0,1-2.25-2.24h0a2.25,2.25,0,0,1,2.25-2.25h9a2.25,2.25,0,0,1,2.25,2.25h0A2.24,2.24,0,0,1,251.32,401Z"
        style={{
          fill: "#213E60",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "246.82px 398.755px",
        }}
        id="eln5cylwt8bw"
        className="animable"
      />
      <path
        d="M275.12,370.42a9.44,9.44,0,1,0,9.44,9.44A9.43,9.43,0,0,0,275.12,370.42Zm0,14.14a4.71,4.71,0,1,1,4.71-4.7A4.7,4.7,0,0,1,275.12,384.56Z"
        style={{
          fill: "#213E60",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "275.12px 379.86px",
        }}
        id="elf1t0lp49p5k"
        className="animable"
      />
      <path
        d="M275.17,370.42v4.73a4.71,4.71,0,1,1-3.63,7.72l-3.74,2.92a9.43,9.43,0,1,0,7.37-15.37Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "276.177px 379.85px",
        }}
        id="elzd7uqnnjk0g"
        className="animable"
      />
      <path
        d="M279.62,401h-9a2.24,2.24,0,0,1-2.25-2.24h0a2.24,2.24,0,0,1,2.25-2.25h9a2.25,2.25,0,0,1,2.25,2.25h0A2.24,2.24,0,0,1,279.62,401Z"
        style={{
          fill: "#213E60",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.987488px",
          transformOrigin: "275.12px 398.755px",
        }}
        id="elpgslqf1if5a"
        className="animable"
      />
    </g>
    <g
      id="freepik--Character--inject-7"
      className="animable"
      style={{
        transformOrigin: "183.21px 286.705px",
      }}
    >
      <circle
        cx={178.2}
        cy={182.68}
        r={42.24}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "178.2px 182.68px",
        }}
        id="elz3ovx0nty7"
        className="animable"
      />
      <path
        d="M191,417.68s6.1,9.17,5.26,12.8-6.2,2.51-8.74-1.4-9-9.75-7.83-12.26S188.72,415.45,191,417.68Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.02307px",
          transformOrigin: "187.945px 424.041px",
        }}
        id="elj2xyhealhj"
        className="animable"
      />
      <path
        d="M164.79,417.17s-7.37,10.94-6.19,13.93,5,2.1,7.92-.6,8.75-10.28,8.75-10.28S170.37,414.18,164.79,417.17Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.02307px",
          transformOrigin: "166.871px 424.654px",
        }}
        id="elbuowqo4jwy8"
        className="animable"
      />
      <path
        d="M158.6,431.1a9.09,9.09,0,0,0,5.78-1.13c3.36-1.7,9.22-9.37,9.22-9.37"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.767303px",
          transformOrigin: "166.1px 425.892px",
        }}
        id="eln0qd2hrxztb"
        className="animable"
      />
      <path
        d="M181.74,418.65s3.19,6,6.78,9.4,5.35,4.37,7.71,2.43"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.767303px",
          transformOrigin: "188.985px 425.059px",
        }}
        id="elsjicdybjcoe"
        className="animable"
      />
      <path
        d="M154.44,280.65s-6.45,13.16-6.16,18.54,1.47,32.6,3.23,41.57S155,372.07,156.2,381s8.89,29.85,8.89,29.85-1.18,4.79-.3,6.28,10.19,3.95,10.48,3.05,1.76-3.59,2-6.28-4.1-31.4-2.34-37.68,2.1-48.5,2.34-52.85-.07-12-.07-12a2.75,2.75,0,0,0,2.94-.89c1.17-1.5,5.05,39.15,6.23,48.72s-1.47,12.26-2.35,18.24-2.93,25.41-2.93,27.81-2.64,10.16-1.47,11.66,3.66,1.25,4.68,1.53c3.06.85,5.45-.48,6.62-.78s2.16-4.63,2.16-4.63,9.42-26.62,11.18-37.69,4.69-31.61,4.11-44.17-4.11-38-4.11-38l-.88-7.48Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.02307px",
          transformOrigin: "178.358px 350.511px",
        }}
        id="elre5x1dvpbr"
        className="animable"
      />
      <path
        d="M150.32,295.87s-.57,7.38,4.26,12.2"
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.506629px",
          transformOrigin: "152.44px 301.97px",
        }}
        id="elm4529ajtpz"
        className="animable"
      />
      <path
        d="M150.6,306.37s2.84,4.83,6.25,5.39"
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.506629px",
          transformOrigin: "153.725px 309.065px",
        }}
        id="el3nr7n8s7kgx"
        className="animable"
      />
      <path
        d="M173.3,387.13s-4,9.54-4.54,14.75,4.54,3.18,5.68,6.65-6.81,3.19-5.39,4.05,5.67,1.45,5.67,1.45"
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.511535px",
          transformOrigin: "171.72px 400.58px",
        }}
        id="el91okexj0yvt"
        className="animable"
      />
      <path
        d="M181,410.85c.85-.29,10.5-2,9.36-7.23s-6.81-5.5-6-11.57S194,372.66,194,368.9s-6.24-17.77-6.81-26.45"
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.511535px",
          transformOrigin: "187.5px 376.65px",
        }}
        id="elobjllmpmils"
        className="animable"
      />
      <path
        d="M194.87,295.31s-6.53,9.36-7.38,10.78,7.66-6.24,7.66-6.24"
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.506629px",
          transformOrigin: "191.29px 300.788px",
        }}
        id="elnmi49axp8rs"
        className="animable"
      />
      <path
        d="M177.79,292s.71,6.84.71,8.25v7.79"
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.506629px",
          transformOrigin: "178.145px 300.02px",
        }}
        id="elg2kgswf2rkf"
        className="animable"
      />
      <path
        d="M178.5,303.8s3.07-.47,3.77-2.83.48-7.08.48-7.08"
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.506629px",
          transformOrigin: "180.641px 298.845px",
        }}
        id="elmj2k27e6tfg"
        className="animable"
      />
      <path
        d="M237.75,210.84c-3.52-10.27-4.11-15.84-4.4-18.77s-3.52-2.06-3.52-2.06-7,4.11-7,5,3.23,22.59,3.81,26.4a49,49,0,0,1,.59,6.75s-12.32-13.2-15.55-16.43c-2.46-2.47-4.41-4.58-6.5-5.84-1.13-1-3.09-1.37-6.11-2.37-5.28-1.76-10.85-5.87-17.31-5.58a38.4,38.4,0,0,0-12.32,2.94s-9.38,4.4-15.84,7.33a11.52,11.52,0,0,0-2.13,1.24c-1.06-.13-3.27.44-5.79,6.09-3.51,7.92-19.35,28.75-22,36.08s2.93,14.67,9.09,20.53a176.1,176.1,0,0,1,12.61,13.79l7-8.62a40.67,40.67,0,0,0,1,5.69c.88,2.93,3.81,6.16,15.55,7s38.11,2.46,37.25-3.52c-1.21-8.5-.59-35.79-1.17-43.12a123.62,123.62,0,0,1,.29-14.1c1.35,1.71,4,4.88,5.85,6.13,2.64,1.76,13.8,10,18.2,11.78s10.56-1.17,13.2-7S241.27,221.11,237.75,210.84Zm-95.62,48.69c-1.18-4.69-1.76-6.45-1.76-6.45s7.52-8.1,11.14-12.42c.49,11.59.8,24.27.46,26.13a43.51,43.51,0,0,0,.21,9.36C150.22,273.46,143.13,263.57,142.13,259.53Z"
        style={{
          fill: "#213E60",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "183.21px 240.375px",
        }}
        id="el7zfhhpbl5yl"
        className="animable"
      />
      <g id="elitjg92evoe">
        <path
          d="M237.75,210.84c-3.52-10.27-4.11-15.84-4.4-18.77s-3.52-2.06-3.52-2.06-7,4.11-7,5,3.23,22.59,3.81,26.4a49,49,0,0,1,.59,6.75s-12.32-13.2-15.55-16.43c-2.46-2.47-4.41-4.58-6.5-5.84-1.13-1-3.09-1.37-6.11-2.37-5.28-1.76-10.85-5.87-17.31-5.58a38.4,38.4,0,0,0-12.32,2.94s-9.38,4.4-15.84,7.33a11.52,11.52,0,0,0-2.13,1.24c-1.06-.13-3.27.44-5.79,6.09-3.51,7.92-19.35,28.75-22,36.08s2.93,14.67,9.09,20.53a176.1,176.1,0,0,1,12.61,13.79l7-8.62a40.67,40.67,0,0,0,1,5.69c.88,2.93,3.81,6.16,15.55,7s38.11,2.46,37.25-3.52c-1.21-8.5-.59-35.79-1.17-43.12a123.62,123.62,0,0,1,.29-14.1c1.35,1.71,4,4.88,5.85,6.13,2.64,1.76,13.8,10,18.2,11.78s10.56-1.17,13.2-7S241.27,221.11,237.75,210.84Zm-95.62,48.69c-1.18-4.69-1.76-6.45-1.76-6.45s7.52-8.1,11.14-12.42c.49,11.59.8,24.27.46,26.13a43.51,43.51,0,0,0,.21,9.36C150.22,273.46,143.13,263.57,142.13,259.53Z"
          style={{
            opacity: 0.1,
            transformOrigin: "183.21px 240.375px",
          }}
          className="animable"
          id="el848e4d2gr7q"
        />
      </g>
      <path
        d="M155.14,239.4a58.91,58.91,0,0,0,4.83-8.79"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.759943px",
          transformOrigin: "157.555px 235.005px",
        }}
        id="elu405lq6gvtd"
        className="animable"
      />
      <path
        d="M162.52,231.46a11.25,11.25,0,0,1-2.84,3.69"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.759943px",
          transformOrigin: "161.1px 233.305px",
        }}
        id="el1duljcjr4vl"
        className="animable"
      />
      <path
        d="M227.19,228.15a12.8,12.8,0,0,0,4,9"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "229.19px 232.65px",
        }}
        id="eltfbo97uxa"
        className="animable"
      />
      <path
        d="M228.35,232.88a12.91,12.91,0,0,0,1.71,7.66"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "229.179px 236.71px",
        }}
        id="elr938wnkqd9e"
        className="animable"
      />
      <path
        d="M140.37,253.08s-2.16-2.05-7.49-1.16"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.759943px",
          transformOrigin: "136.625px 252.388px",
        }}
        id="elzpqol84wmq"
        className="animable"
      />
      <path
        d="M129.93,250.74s1.48-2.37,7.09-.6"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.759943px",
          transformOrigin: "133.475px 250.112px",
        }}
        id="el3fcychr2h0e"
        className="animable"
      />
      <path
        d="M211.54,220.28c-1.18.29-6.21,8.87-6.21,8.87l12.13-3.25"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.759943px",
          transformOrigin: "211.395px 224.715px",
        }}
        id="elfvmla3yp2k"
        className="animable"
      />
      <path
        d="M176.71,214.43s2.27,3.12,7.38,1.71,6.81-6.81,6-10.22S172.17,205.35,176.71,214.43Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "183.114px 210.515px",
        }}
        id="elkf8e3th3wx"
        className="animable"
      />
      <path
        d="M171.85,195s-3.43,2.28-3.88,4.34.68,8.67,1.59,10.95,3.89,7.53,3.89,7.53,10.27-5.93,11-6.39,8,3.65,9.59,3-3.88-14.61-6.39-17.57S175.5,192.25,171.85,195Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "181.096px 205.708px",
        }}
        id="el0ly020tqggjc"
        className="animable"
      />
      <path
        d="M170,187.46s.23,3.65.69,9.13S173,206.4,176,208.91s7.3,3.88,8.44,2.51,2.51-7.07,2-10.5-1.14-10.72-1.14-10.72Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "178.275px 199.711px",
        }}
        id="elejuvxdn4jj"
        className="animable"
      />
      <g id="ellb10kt78z3">
        <path
          d="M186,196.65c-.34-3.19-.65-6.45-.65-6.45L170,187.46s.23,3.65.69,9.13a23.47,23.47,0,0,0,1.73,7.37Z"
          style={{
            fill: "#213E60",
            opacity: 0.5,
            mixBlendMode: "multiply",
            transformOrigin: "178px 195.71px",
          }}
          className="animable"
          id="elvo0y64zcto"
        />
      </g>
      <path
        d="M165,182s-3.42-3.42-4.11-.46,2.06,7.54,5.94,6.39v-2.73Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "163.807px 184.223px",
        }}
        id="elu6kqwqlsyhc"
        className="animable"
      />
      <g id="elwssditt97d">
        <path
          d="M165,182s-3.42-3.42-4.11-.46,2.06,7.54,5.94,6.39v-2.73Z"
          style={{
            fill: "#213E60",
            stroke: "rgb(38, 50, 56)",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.01326px",
            opacity: 0.5,
            transformOrigin: "163.807px 184.223px",
          }}
          className="animable"
          id="elztgqoe2dt3"
        />
      </g>
      <path
        d="M162,175.82s5.71,15.29,10.73,18.26,15.06,5.7,17.8-5-4.56-26.25-7.07-30.82-11.87-5.93-17.8-1.37S158.38,165.77,162,175.82Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "175.569px 175.409px",
        }}
        id="elrbu9wmwtpr"
        className="animable"
      />
      <g id="ellcqf873bf7">
        <path
          d="M168.33,162.87a19.55,19.55,0,0,1,7.72-1.8l5.69-4.79c-3.74-2.88-11.09-3.23-16.05.59-5.94,4.57-7.31,8.9-3.66,18.95,0,0,5.71,15.29,10.73,18.26a20.53,20.53,0,0,0,5.72,2.29c-2.42-3.12-6.14-8.08-7.32-10.61-1.8-3.86-2.57-11.83-4.89-16.46S164.73,164.67,168.33,162.87Z"
          style={{
            fill: "#213E60",
            opacity: 0.5,
            mixBlendMode: "multiply",
            transformOrigin: "170.879px 175.216px",
          }}
          className="animable"
          id="elxypm236crrf"
        />
      </g>
      <path
        d="M180.29,171.25s2.28,4.11,1.37,5a2.37,2.37,0,0,1-2.28.46"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "180.627px 174.038px",
        }}
        id="elwx5vjb6mhod"
        className="animable"
      />
      <path
        d="M169.79,170.57s.46-2.74,3.88-2.74"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2.02651px",
          transformOrigin: "171.73px 169.2px",
        }}
        id="elhl84sz90br"
        className="animable"
      />
      <path
        d="M171.85,173.31s2.51,1.14,3.42-1.37"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "173.56px 172.754px",
        }}
        id="el9nm1vp4oq3f"
        className="animable"
      />
      <path
        d="M182.8,171.48s2.51,1.14,3.43-1.37"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "184.515px 170.924px",
        }}
        id="elt5r51q5re9"
        className="animable"
      />
      <path
        d="M180.72,166.24a3.42,3.42,0,0,1,4.68-.19"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2.02651px",
          transformOrigin: "183.06px 165.728px",
        }}
        id="el0lz38ecmafb"
        className="animable"
      />
      <path
        d="M191,180.29c-2.66-1.16-9-3.72-11.12-2.65-2.74,1.37-9.82,6.17-9.82,9.82,0,0-4.56-6.16-4.56-8.45s1.82-3,.23-5.93-3.89-3.2-3.2-6.62c.63-3.17,6.94-6.53,10-7a10.32,10.32,0,0,0,6.85,2.44c5,0,9.13-3.21,9.13-7.19s-4.09-7.18-9.13-7.18a11.08,11.08,0,0,0-3.31.49c-4.78-.35-5.69,3.19-9,5.13s-5.39,7.66-5.39,7.66l.14,0c-2.42,3.54-2.41,7.81.22,15,0,0,5.71,15.29,10.73,18.26s15.06,5.7,17.8-5A24.77,24.77,0,0,0,191,180.29Z"
        style={{
          fill: "rgb(38, 50, 56)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "175.621px 172.131px",
        }}
        id="elpr8qh262phk"
        className="animable"
      />
      <path
        d="M185.55,180.06s-3.42,4.79-7.3,1.6"
        style={{
          fill: "none",
          stroke: "rgb(255, 255, 255)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "181.9px 181.408px",
        }}
        id="elsn0kcxpnd0g"
        className="animable"
      />
      <path
        d="M152.68,276.84a13.47,13.47,0,0,1,3.52,3.22,58.66,58.66,0,0,0,3.82,4.7s3.22.29,2.93,1.76-.88,2.34-2.35,2.34-4.69-2.93-4.69-2.93l-4.69,7.33s-4.4-3.22-5.87-7.33Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "154.159px 285.05px",
        }}
        id="eleixnt6ohvdf"
        className="animable"
      />
      <circle
        cx={178.2}
        cy={182.68}
        r={42.24}
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2.02651px",
          transformOrigin: "178.2px 182.68px",
        }}
        id="elzesw2zt78zg"
        className="animable"
      />
      <path
        d="M216.34,174.47s-2.94-.3-3.52,1.46-1.47,3.52-1.47,4.7.29,2.05,1.76,2.34,2.35-1.76,2.35-1.76Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "213.845px 178.724px",
        }}
        id="elzenwajqadu"
        className="animable"
      />
      <path
        d="M216.92,172.41s-1.46,7.92-1.46,10.27a8.88,8.88,0,0,0,1.76,5,3.65,3.65,0,0,0,2.05,1.17l1.47-1.76s-1.76,2.35.58,5.28,4.11,2.64,6.16,1.76,2.64-2.05,1.76-5.28-1.46-8.51-2.05-11.73-2.64-4.4-3.81-4.4S219,171.53,216.92,172.41Z"
        style={{
          fill: "rgb(255, 255, 255)",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.01326px",
          transformOrigin: "222.548px 183.41px",
        }}
        id="el99tm0c5i7m7"
        className="animable"
      />
      <path
        d="M215.85,184.33s-.52-1.82,1.69-2.08,5.86-.65,5.86-.65"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.506629px",
          transformOrigin: "219.598px 182.965px",
        }}
        id="el361f89sgilg"
        className="animable"
      />
      <path
        d="M216.11,179.65s5.07-1.31,6.9-1.05"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.506629px",
          transformOrigin: "219.56px 179.108px",
        }}
        id="elcc0uuc98x5"
        className="animable"
      />
      <path
        d="M216.5,176a33.75,33.75,0,0,1,5.73-.52"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.506629px",
          transformOrigin: "219.365px 175.74px",
        }}
        id="elo1q3u6404no"
        className="animable"
      />
      <path
        d="M218.19,185.76a3.39,3.39,0,0,0,3,.79"
        style={{
          fill: "none",
          stroke: "rgb(38, 50, 56)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.506629px",
          transformOrigin: "219.69px 186.195px",
        }}
        id="elsd4yv8pvpjf"
        className="animable"
      />
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
);
export default PersonalPortfoiliSVG;
